// @ts-nocheck
/* eslint-disable */
/**
 * 初始化Intercom实例的脚本
 *
 * @param sdkUrl - Intercom 脚本地址
 *
 * @see https://developers.intercom.com/installing-intercom/docs/basic-javascript
 */
const initIntercom = (sdkUrl: string) => {
    return new Promise<void>((resolve, reject) => {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === 'function') {
            ic('update', w.intercomSettings);
            resolve();
        } else {
            var d = document;
            var i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function () {
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = sdkUrl;
                s.addEventListener('error', reject);
                s.addEventListener('load', resolve);
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === 'complete') {
                l();
            } else if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    });
};

export default initIntercom;
